import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-login__wrapper" }

import { ILoginData } from 'Auth';
import { IModalEmits } from 'Modal';
import FormLogin from 'Components/FormLogin/FormLogin.vue';
import { BaseModal } from 'Components/Base/BaseModal';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalLogin',
  props: {
    redirectOnSignup: {}
  },
  emits: ["success", "cancel", "error"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

function onSuccess(loginData: ILoginData) {
  emit('success', loginData);
}

function onCancel() {
  emit('cancel');
}

function onError(error: unknown) {
  emit('error', error);
}

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseModal), {
    class: "ModalLogin modal-login",
    show: "",
    size: "small",
    onClose: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "modal-login__title" }, "Log In", -1)),
        _createVNode(FormLogin, {
          "redirect-on-signup": props.redirectOnSignup,
          onSuccess: onSuccess,
          onError: onError
        }, null, 8, ["redirect-on-signup"])
      ])
    ]),
    _: 1
  }))
}
}

})